import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { FileCheck2, ShieldCheck, Wrench } from "lucide-react";

export default function Login() {
  const { login, formatErr } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try { await login(email, password); nav("/app/dashboard"); }
    catch (e) { setErr(formatErr(e)); }
    finally { setLoading(false); }
  };

  return (
    <div className="app-bg grain min-h-screen flex items-center justify-center p-4 relative z-10">
      <div className="w-full max-w-5xl grid lg:grid-cols-2 gap-10 items-center">
        <div className="hidden lg:block space-y-6">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-amber-500/30 bg-amber-500/10 text-amber-300 font-mono text-xs tracking-wider">
            <Wrench size={14}/> KFZ FAKTURA · ZUGFeRD 2.5
          </div>
          <h1 className="font-display text-5xl font-extrabold leading-tight">
            Ihre freewarefaktura<br/>PDF-Rechnungen<br/>
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-amber-400">E-Rechnungs-konform.</span>
          </h1>
          <p className="text-slate-400 text-lg leading-relaxed">
            Konvertieren Sie bestehende Werkstatt-Rechnungen zu <b className="text-slate-200">ZUGFeRD 2.5 / Factur-X</b> oder <b className="text-slate-200">XRechnung 3.0</b>. KI-gestützte Datenerkennung, manuelle Freigabe, PDF/A-3 Download. Für KFZ-Werkstätten & KFZ-Handel.
          </p>
          <div className="flex flex-wrap gap-4 pt-4">
            <div className="flex items-center gap-2 text-slate-300"><ShieldCheck size={18} className="text-emerald-400"/> EN 16931 konform</div>
            <div className="flex items-center gap-2 text-slate-300"><FileCheck2 size={18} className="text-blue-400"/> B2B & B2G ready</div>
          </div>
        </div>

        <div className="card p-8 fade-in">
          <h2 className="font-display text-2xl font-bold mb-1">Anmeldung</h2>
          <p className="text-slate-400 text-sm mb-6">Willkommen zurück. Melden Sie sich an, um fortzufahren.</p>
          <form onSubmit={onSubmit} className="space-y-4" data-testid="login-form">
            <div>
              <label className="label">E-Mail</label>
              <input className="input" type="email" required value={email} onChange={e=>setEmail(e.target.value)} data-testid="login-email-input" placeholder="meister@werkstatt.de"/>
            </div>
            <div>
              <label className="label">Passwort</label>
              <input className="input" type="password" required value={password} onChange={e=>setPassword(e.target.value)} data-testid="login-password-input" placeholder="••••••••"/>
            </div>
            {err && <div data-testid="login-error" className="text-sm text-rose-300 bg-rose-500/10 border border-rose-500/30 rounded-lg p-3">{err}</div>}
            <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="login-submit-button">
              {loading ? <span className="spinner"/> : "Anmelden"}
            </button>
            <div className="text-xs text-slate-500 text-center pt-2" data-testid="no-self-registration-hint">
              Kein Konto? Bitte wenden Sie sich an Ihren Administrator.
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
